<template>
  <div style="background-color: lightgray" class="player-container">
    <div class="header-title">
      <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"
        ><van-icon name="revoke"></van-icon
      ></span>
      使用教程
    </div>
    <div class="sub-continner" style="margin-top: 7.8rem;">
      <div class="main-card">
        <div class="main-card-content">
          提示：显示为使用教程，点击视频即可播放，点击返回按钮返回上一页
          <div v-show="false">
            养号：点击准备中的要养的账号，选中点开始养号！
          </div>
        </div>
      </div>

      <div class="video-list-page">
        <van-cell
          v-for="(video, index) in videos"
          :key="index"
          class="video-item"
          @click="goToPlayer(video)"
          is-link
        >
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <span class="custom-title">{{ video.title }}</span>
            <!-- <van-tag type="danger">{{ video.src }}</van-tag> -->
          </template>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { mixins } from "../../mixins/mixins";
export default {
  name: "TeacherPageList",
  mixins: [mixins],
  data() {
    return {
      // 模拟视频数据，实际可从 API 获取
      videos: [
        {
            title: "1.平台介绍",
            src: "https://ai.weiquanai.com:5136/1.mp4",
        },
        {
          title: "2.创建钱包",
          src: "https://ai.weiquanai.com:5136/2.mp4",
        },
        {
          title: "3.绑定收款地址",
          src: "https://ai.weiquanai.com:5136/3.mp4",
        },
        {
            title: "4.买币教程",
            src: "https://ai.weiquanai.com:5136/4.mp4",
        },
        {
          title: "5.充值教程",
          src: "https://ai.weiquanai.com:5136/5.mp4",
        },
        {
            title: "6.养号和下单教程",
            src: "https://ai.weiquanai.com:5136/6.mp4",
        },
        {
          title: "7.申诉和退款教程",
          src: "https://ai.weiquanai.com:5136/7.mp4",
        },
        {
          title: "8.提现教程",
          src: "https://ai.weiquanai.com:5136/8.mp4",
        },
        {
            title: "9.站内转账教程",
            src: "https://ai.weiquanai.com:5136/9.mp4",
        },
        {
            title: "10.卖币教程",
            src: "https://ai.weiquanai.com:5136/10.mp4",
        },
        
      ],
    };
  },
  methods: {
    goToPlayer(video) {
      // 跳转到播放页面，通过 query 传递 title 和 src
      this.$router.push({
        path: "/player",
        query: {
          title: video.title,
          src: video.src,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../root.scss";
.player-container {
  background-color: rgb(249, 249, 249);
  background-image: url(../../assets/img/thembg.png);
  background-repeat: no-repeat;
  background-size: contain;
  height: 100dvh;
  position: relative;
}

::v-deep .van-count-down {
  color: #f55033;
}

::v-deep .van-cell__title {
  width: 55%;
}

.van-cell span,
.van-cell div {
  font-size: calculeResultFontSize(false, 2px) !important;
}

.time_div div {
  font-size: 12px !important;
}

.item-second-content {
  color: #ffffff;
}

.selected {
  color: #f55033;
}
</style>
